// extracted by mini-css-extract-plugin
export default {"numberFilterInputField":"X6A_i7s"};